import React from 'react';
import styles from '../AppointmentManagement/AppointmentManagement.module.css';

// SVG Icon
const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 2H16V1C16 0.45 15.55 0 15 0C14.45 0 14 0.45 14 1V2H6V1C6 0.45 5.55 0 5 0C4.45 0 4 0.45 4 1V2H3C1.9 2 1 2.9 1 4V18C1 19.1 1.9 20 3 20H17C18.1 20 19 19.1 19 18V4C19 2.9 18.1 2 17 2ZM17 18H3V8H17V18Z"
      fill="currentColor"
    />
  </svg>
);

export const NoAppointmentsState: React.FC = () => {
  return (
    <div className={styles.noAppointments}>
      <div className={styles.noAppointmentsIcon}>
        <CalendarIcon />
      </div>
      <div className={styles.noAppointmentsTitle}>No appointments found</div>
      <div className={styles.noAppointmentsMessage}>You don&apos;t have any scheduled appointments at this time.</div>
    </div>
  );
};
